module.exports = __webpack_public_path__ + "img/min.ab70c69f.png";